export var KnownDocumentActionIdPrefix;
(function (KnownDocumentActionIdPrefix) {
    KnownDocumentActionIdPrefix["addTo"] = "addTo";
    KnownDocumentActionIdPrefix["convertToPdf"] = "convertToPdf";
    KnownDocumentActionIdPrefix["copyLink"] = "copyLink";
    KnownDocumentActionIdPrefix["delete"] = "delete";
    KnownDocumentActionIdPrefix["download"] = "download";
    KnownDocumentActionIdPrefix["edit"] = "edit";
    KnownDocumentActionIdPrefix["favorite"] = "favorite";
    KnownDocumentActionIdPrefix["hide"] = "hide";
    KnownDocumentActionIdPrefix["openInApp"] = "openInNative";
    KnownDocumentActionIdPrefix["openInBrowser"] = "openInBrowser";
    KnownDocumentActionIdPrefix["openFileLocation"] = "openFileLocation";
    KnownDocumentActionIdPrefix["share"] = "share";
    KnownDocumentActionIdPrefix["tag"] = "tag";
    KnownDocumentActionIdPrefix["unfavorite"] = "unfavorite";
    KnownDocumentActionIdPrefix["unhide"] = "unhide";
    KnownDocumentActionIdPrefix["moveTo"] = "moveTo";
})(KnownDocumentActionIdPrefix || (KnownDocumentActionIdPrefix = {}));
//# sourceMappingURL=KnownDocumentActionIdPrefix.js.map